// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.practicepay.PracticePayInitializePaymentSessionRequest */
/* istanbul ignore next */
@GandalfModel
export class PracticePayInitializePaymentSessionRequest extends GandalfModelBase {

	@GandalfLabel('Amount')
	@GandalfValidator({ notNull: { message: 'Amount is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	amount!: number;

	@GandalfLabel('Entity ID')
	@GandalfValidator({ notNull: { message: 'Entity ID is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	entityId!: number;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfLabel('Payer Type')
	@GandalfValidator({ notNull: { message: 'Payer Type is required' } })
	@GandalfProperty({ designType: constants.PayerType, isRequired: true })
	payerType!: constants.PayerType;

	@GandalfLabel('Practice Location')
	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

}
